import React from 'react';

import { Box, Typography, useTheme } from '@mui/material';

type CompanyAddressProps = {
  name: string;
  address: string;
};

const CompanyAddress = ({ name, address }: CompanyAddressProps) => {
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Typography variant="body2lanna" color={theme.palette.textV2.primary} sx={{ fontWeight: 700 }}>
        {name}
      </Typography>
      <Typography variant="body2lanna" color={theme.palette.textV2.primary}>
        {address}
      </Typography>
    </Box>
  );
};

export default CompanyAddress;
